/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { CartDataFragmentDoc } from '../../../hooks/useCart/GraphQL/Cart.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GroupOrderRestaurantQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GroupOrderRestaurantQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly name: string;
    readonly isOutpost: boolean;
    readonly address: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
  } | null;
};

export type GroupOrderDeliveryLocationQueryVariables = Types.Exact<{
  input: Types.LocationByAddressIdInput;
  addressId: Types.Scalars['ID']['input'];
}>;

export type GroupOrderDeliveryLocationQuery = {
  readonly __typename?: 'Query';
  readonly address: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly name: string | null;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
  } | null;
  readonly locationByAddressId:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly name: string;
          readonly deliveryFee: number;
        };
        readonly vendor: {
          readonly __typename?: 'Vendor';
          readonly name: string;
          readonly restaurantId: string;
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export type GroupOrderCreateOrderMutationVariables = Types.Exact<{
  input: Types.CreateOrderInput;
}>;

export type GroupOrderCreateOrderMutation = {
  readonly __typename?: 'Mutation';
  readonly createOrder:
    | {
        readonly __typename: 'CreateOrderSuccess';
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly orderState: Types.OrderState;
          readonly canTrackOrderStatus: boolean;
          readonly currentUserOrderPermissions: {
            readonly __typename?: 'UserOrderPermission';
            readonly canSubmitOrder: boolean;
          };
          readonly multipartyDetails: {
            readonly __typename?: 'MultipartyDetail';
            readonly joinCode: string;
          } | null;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly enableDressingDetails: boolean;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
            readonly selectedModifiers: ReadonlyArray<{
              readonly __typename?: 'SelectedModifier';
              readonly id: number;
              readonly modifierType: Types.ModifierType | null;
              readonly cost: number;
              readonly parentId: number | null;
              readonly ingredient: {
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              } | null;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly showDeliveryFeeDisclosure: boolean;
            readonly deliveryFee: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
            readonly deliveryOffset: number;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
        };
      }
    | { readonly __typename: 'MultipartyOrderNotEnabled'; readonly errorMessage: string }
    | { readonly __typename: 'UnauthorizedOrderModification'; readonly errorMessage: string }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const GroupOrderRestaurantDocument = gql`
  query GroupOrderRestaurant($id: ID!) {
    restaurant(id: $id) {
      id
      __typename
      name
      isOutpost
      address
      city
      state
      zipCode
    }
  }
`;

export function useGroupOrderRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<GroupOrderRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GroupOrderRestaurantQuery, GroupOrderRestaurantQueryVariables>({
    query: GroupOrderRestaurantDocument,
    ...options,
  });
}
export const GroupOrderDeliveryLocationDocument = gql`
  query GroupOrderDeliveryLocation($input: LocationByAddressIdInput!, $addressId: ID!) {
    address(addressId: $addressId) {
      id
      __typename
      name
      street
      secondaryStreet
      city
      state
      zipCode
    }
    locationByAddressId(input: $input) {
      __typename
      ... on Location {
        restaurant {
          id
          __typename
          name
          deliveryFee
        }
        vendor {
          name
          restaurantId
        }
      }
    }
  }
`;

export function useGroupOrderDeliveryLocationQuery(
  options: Omit<Urql.UseQueryArgs<GroupOrderDeliveryLocationQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GroupOrderDeliveryLocationQuery, GroupOrderDeliveryLocationQueryVariables>({
    query: GroupOrderDeliveryLocationDocument,
    ...options,
  });
}
export const GroupOrderCreateOrderDocument = gql`
  mutation GroupOrderCreateOrder($input: CreateOrderInput!) {
    createOrder(input: $input) {
      __typename
      ... on CreateOrderSuccess {
        order {
          ...CartData
        }
      }
      ... on MultipartyOrderNotEnabled {
        errorMessage
      }
      ... on UnauthorizedOrderModification {
        errorMessage
      }
      ... on ValidationError {
        message
        fieldErrors {
          field
          message
        }
      }
    }
  }
  ${CartDataFragmentDoc}
`;

export function useGroupOrderCreateOrderMutation() {
  return Urql.useMutation<GroupOrderCreateOrderMutation, GroupOrderCreateOrderMutationVariables>(
    GroupOrderCreateOrderDocument,
  );
}
